export enum HistoryAPIRoutes {
    GET_ACTIVITY_LOGS = "history:action_records:query",
    GET_HISTORY_USERS = "auth:users:query"
}
